import { BitfNetResponseMapper } from '@common/libs/bitforce/core/parsers/net-parser';

export class AppResponseMapper extends BitfNetResponseMapper {}
